import Vue from 'vue'
import VueRouter from 'vue-router'

// Components
import Home from '@/views/Home.vue'
import Fields from '@/views/Fields.vue'
import Questionnaire from '@/views/Questionnaire.vue'
import Results from '@/views/Results.vue'
import About from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import PageNotFound from '@/views/PageNotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/tomeis',
    name: 'Fields',
    component: Fields
  },
  {
    path: '/erwthmatologio/:quest?/:questlevel?',
    name: 'Questionnaire',
    component: Questionnaire
  },
  {
    path: '/apotelesmata',
    name: 'Results',
    component: Results,
    props: true
  },
  {
    path: '/gia-emas',
    name: 'About',
    component: About
  },
  {
    path: '/epikoinwnia',
    name: 'Contact',
    component: Contact
  },
  { path: '*', component: PageNotFound }
]
const locale = window.location.pathname.replace(/^\/([^/]+).*/i, '$1')
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL + locale,
  routes
})

export default router
